import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon, F0Text } from '@factorialco/f0-react'
import { PalmTree } from '@factorialco/f0-react/icons/app'
import moment from 'moment'

import { i18nDateToString } from 'modules/core/lib/dates'
import type { LeaveGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const LeaveCard: EventCardSpec<LeaveGridEvent> = {
  getAppearance: () => ({
    background: 'grey200',
    opacity: '1',
    border: undefined,
    fillHeight: true,
  }),
  render: (event) => {
    const startDate = moment(event.start)
    const endDateInclusive = moment(event.end).subtract(1, 'day')
    const startLabel = i18nDateToString(startDate, 'ui_short')
    const endLabel = i18nDateToString(endDateInclusive, 'ui_short')
    const rangeLabel = startDate.isSame(endDateInclusive, 'day')
      ? startLabel
      : `${startLabel} → ${endLabel}`

    return (
      <Box flexDirection="column" gap="s4" paddingBottom="s6">
        <Box flexDirection="row" alignItems="center" gap="s4">
          <F0Icon icon={PalmTree} size="sm" color="secondary" />
          <F0Text
            variant="label"
            content={event.leave.halfDay ? `½ ${event.leave.typeName}` : event.leave.typeName}
            ellipsis
          />
        </Box>
        <Box paddingLeft="s4">
          <F0Text variant="label" content={rangeLabel} ellipsis />
        </Box>
      </Box>
    )
  },
}

export { LeaveCard }
